// JS dependency
var slick = require('slick-carousel');

// CSS dependency
import '/../node_modules/slick-carousel/slick/slick.css';

// Example
$('#slick-category').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  fade: false,
  arrows: true,
  autoplay: true,
  adaptiveHeight: true,
  cssEase: 'ease-in-out',
  speed: 400,
  autoplaySpeed: 6000,
  appendArrows: '#slick-category-arrows',
  prevArrow: '<button class="arrow-prev"><span class="sprite slider-prev"></span></button>',
  nextArrow: '<button class="arrow-next"><span class="sprite slider-next"></span></button>',
  responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
  ]
});

$('#slick-blog').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  fade: false,
  arrows: true,
  autoplay: true,
  adaptiveHeight: true,
  cssEase: 'ease-in-out',
  speed: 400,
  autoplaySpeed: 6000,
  appendArrows: '#slick-blog-arrows',
  prevArrow: '<button class="arrow-prev"><span class="sprite slider-prev"></span></button>',
  nextArrow: '<button class="arrow-next"><span class="sprite slider-next"></span></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
      }
    },
  ]
});


$('.slick-product').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  fade: false,
  arrows: false,
  autoplay: true,
  adaptiveHeight: false,
  cssEase: 'ease-in-out',
  speed: 400,
  autoplaySpeed: 6000,
  responsive: [{
      breakpoint: 1200,
      settings: {}
    },
    {
      breakpoint: 991,
      settings: {}
    },
    {
      breakpoint: 576,
      settings: {
        autoplay: false
      }
    },
  ]
});

$('.slick-product-nav').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: false,
    fade: false,
    arrows: true,
    autoplay: false,
    adaptiveHeight: false,
    cssEase: 'ease-in-out',
    speed: 400,
    autoplaySpeed: 6000,
    vertical: true,
    prevArrow: '<button type="button" class="slick-prev back-top sprite"></button>',
    nextArrow: '<button type="button" class="slick-next arrow-select sprite"></button>'
});


$('.slick-product-nav > div:first-child .button').addClass('active');

$('.slick-product').on('afterChange', function() {
  var dataId = $('.slick-current').attr("data-slick-index");
  $('.slick-product-nav .button').removeClass('active');
  $('.slick-product-nav > div').eq(dataId).find('.button').addClass('active');
});

$(".slick-product-nav .button").on('click', function(){
  var number = $(this).attr('data-trigger');
  $('.slick-product').slick('slickGoTo', parseInt(number-1), false);
});



$('#slick-car-inside, #slick-car-outside').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  fade: false,
  arrows: false,
  autoplay: false,
  adaptiveHeight: true,
  cssEase: 'ease-in-out',
  speed: 400,
  autoplaySpeed: 6000,
});
